import { GIGS_VIEW_ACTIONS } from '../actions';

const initState = ({ gigs = [], total = 0, hasMorePages = false, lastItemId }) => ({
    gigs,
    total,
    hasMorePages,
    lastItemId,
});

const gigsViewReducer =
    (gigsData) =>
    (state = initState(gigsData), action = {}) => {
        const { type, data } = action;

        switch (type) {
            case GIGS_VIEW_ACTIONS.SET:
                return {
                    ...state,
                    gigs: data.gigs,
                    hasMorePages: data.hasMorePages,
                    lastItemId: data.lastItemId,
                };
            default:
                return state;
        }
    };

export default gigsViewReducer;
